<template>
  <div class="concept-slider">
    <carousel  
    :navigationEnabled="false"
    :loop="true"
    :paginationEnabled="false"
    :perPageCustom="[[320,1],[1440, 3],]"
    >
      <slide class="slide" v-for="(concept, index) in concepts" :key="index">
        <img
          :src="`${siteBase}/${concept.foto}`"
          alt="concept photo"
          draggable="false"
        />
      </slide>

    </carousel>
  </div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel';
import { SITE_BASE, siteApiUrl } from "@/siteBase.js";

export default {
  name: "ConceptSlider",
  components: {
     Carousel,
    Slide
  },

  computed: {
    siteBase() {
      return SITE_BASE;
    },
  },

  data() {
    return {
      concepts:[],
    };
  },

  async mounted() {
    let data = await fetch(siteApiUrl("api/concept.json"));
    let concepts = await data.json()

    this.concepts = concepts;
  }
};
</script>

<style>
</style>